module.exports = __webpack_public_path__ + "img/tourist.b88b85fb.png";